var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
var PageContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: rgba(0, 0, 0, 0.85);\n  padding: 16px;\n  margin: 0 16px 0;\n  flex: 1;\n  ", "\n  ", "\n"])), function (props) {
  return "background-color: ".concat(props.ghostPage ? 'transparent' : '#fff', ";");
}, function (props) {
  return "padding: ".concat(props.padding, "px;");
});
export { PageContent };